"use strict";

var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

var setToString = shortOut(baseSetToString);
module.exports = setToString;